import React from 'react';
import { Route as DefaultRoute, Redirect } from 'react-router-dom';
import { isAuthenticated, deleteToken } from 'client/utils/token';

import Sidebar from 'components/Sidebar';
import Dashboard, { DashContent } from '@bexs/dollar/components/Dashboard';
import Header from 'components/Header';
import { RouteProps } from './types';

const Route: React.FC<RouteProps> = ({
  isPrivate,
  component: Component,
  ...rest
}) => {
  const isSigned = isAuthenticated() ? true : undefined;
  if (!isSigned) {
    deleteToken();
  }
  return (
    <DefaultRoute
      {...rest}
      render={({ location }) =>
        isPrivate === isSigned ? (
          isPrivate ? (
            <Dashboard>
              <Sidebar />
              <DashContent>
                <Header />
                <Component />
              </DashContent>
            </Dashboard>
          ) : (
            <Component />
          )
        ) : (
          <Redirect
            to={{
              pathname: isPrivate && !isSigned ? '/' : '/balance',
              state: {
                from: location,
              },
            }}
          />
        )} //eslint-disable-line
    />
  );
};

export default Route;
